import PageLayout from "@/components/PageLayout";
import { useState, useRef, useEffect, useContext } from "react";
import { loadConfig } from "@/lib/utils.js";
import CartService from "@/lib/services/cart.js";
import Cookies from "cookies";
import SavedItemRow from "@/components/saved_item_row.js";
import SimpleModal from "@/components/simple_modal.js";
import Clipboard from "@/components/clipboard";
import { CartContext } from "@/lib/cart_context.js";
import CartItems from "@/components/cart_items.js";
import CartActions from "@/components/cart_actions.js";
import CartSvg from "@/components/svgs/cart_svg.js";

function SavedItems(results) {
  const { favicon, stylesheet, page_layout, cart_enabled, resource_display,
    enable_asset_multiple_link_download_modal, enable_asset_multiple_link_copying_modal } =
    results;
  const { products } = results;
  const [show, setShow] = useState(false);
  const [pageUrl, setPageUrl] = useState();
  return (
    <PageLayout
      favicon={favicon}
      page_layout={page_layout}
      cart_enabled={cart_enabled}
      stylesheet={results.stylesheet}
      title={"Saved Items"}
    >
      <section className="lexcms-saved-items-page-container">
        <section className="lexcms-saved-items-page-header-container">
          <div className="lexcms-saved-items-page-body-header-text">
            <h1 className="lexcms-saved-items-page-heading">
              <CartSvg />
              Saved Items
            </h1>
            <CartActions setShow={setShow} setPageUrl={setPageUrl} />
          </div>
        </section>
        <section className="lexcms-saved-items-table-container">
          <CartItems config={{enable_asset_multiple_link_copying_modal: enable_asset_multiple_link_copying_modal, enable_asset_multiple_link_download_modal: enable_asset_multiple_link_download_modal }}  items={products} resource_display={resource_display} />
        </section>
      </section>
      <SimpleModal show={show} setShow={setShow}>
        <h3>Share These Saved Items</h3>
        <Clipboard pageUrl={pageUrl} />
      </SimpleModal>
    </PageLayout>
  );
}

export async function getServerSideProps({ req, resp, params }) {
  let token = req.headers['lex-api-token']
  let cookies = new Cookies(req, resp);
  let service = await CartService.build(token, req.headers?.host);
  let results = await service.show({
    session_key: cookies.get("Lex-Cms-Session"),
    resources: true
  });
  let pageLayout = loadConfig(service);
  return {
    props: { ...results, ...pageLayout },
  };
}

export default SavedItems;
